import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { Season } from '@solverml/api';

export interface VideoBasicInfoModalData {
  title: string;
  seasonId: number | null;
  matchDate: string | null;
  seasons: Season[];
  selectedGender: string | null;
  selectedCompetitionId: number | null;
  selectedCategoryId: number | null;
  genderOptions: { id: number; name: string }[];
  competitionOptions: { id: number; name: string }[];
  categoryOptions: { id: number; name: string }[];
}

export interface VideoBasicInfoModalResult {
  title: string;
  season_id: number | null;
  match_date: string | null;
  gender: string | null;
  competition_id: number | null;
  category_id: number | null;
}

@Component({
  selector: 'app-video-basic-info-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule
  ],
  templateUrl: './video-basic-info-modal.component.html',
  styleUrls: ['./video-basic-info-modal.component.scss']
})
export class VideoBasicInfoModalComponent {
  readonly form = this.fb.group({
    title: [this.data.title, [Validators.required, Validators.minLength(3)]],
    season_id: [this.data.seasonId ?? 1, [Validators.required]],
    match_date: [this.data.matchDate ?? this.getTodayDate(), [Validators.required]],
    gender: [this.data.selectedGender ?? null, [Validators.required]],
    competition_id: [this.data.selectedCompetitionId ?? null, [Validators.required]],
    category_id: [this.data.selectedCategoryId ?? null, [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<VideoBasicInfoModalComponent, VideoBasicInfoModalResult>,
    @Inject(MAT_DIALOG_DATA) public data: VideoBasicInfoModalData
  ) {}

  save(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue() as VideoBasicInfoModalResult);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private getTodayDate(): string {
    return new Date().toISOString().slice(0, 10);
  }
}
